import { t } from 'typegate';
const identifierSchema = t.string;
const parentScopeIndexSchema = t.union(t.number, t.literal('n'), t.literal('-'));
const leafScopeIndexSchema = t.union(t.number, t.literal('-'));
const parentScopeSchema = t.record(identifierSchema, parentScopeIndexSchema);
const leafScopeSchema = t.record(identifierSchema, leafScopeIndexSchema);
const jsonPrimitiveSchema = t.union(t.literal('string'), t.literal('number'), t.literal('integer'), t.literal('boolean'), t.literal('null'));
const yesNoToBooleanSchema = t.object(t.property('kind', t.literal('YesNoToBoolean')));
const lowerCaseSchema = t.object(t.property('kind', t.literal('LowerCase')));
const transformSchema = t.discriminatedUnion('kind', yesNoToBooleanSchema, lowerCaseSchema).setTypeName('Transform');
const leafSchema = t
    .object(t.property('path', t.string), t.optionalProperty('scope', leafScopeSchema), t.property('answer', identifierSchema), t.optionalProperty('transform', t.array(transformSchema)), t.optionalProperty('type', jsonPrimitiveSchema))
    .setTypeName('Leaf');
export const parentSchema = t
    .object(t.property('path', t.string), t.optionalProperty('scope', parentScopeSchema), t.property('children', t.array(t.union(leafSchema, t.lazy(() => parentSchema)))))
    .setTypeName('Parent');
const identifierTypeSchema = t.union(t.literal('nodeId'), t.literal('blueprintId'));
export const outputMappingSchema = t.object(t.property('identifierType', identifierTypeSchema), t.property('root', t.array(parentSchema)));
export class OutputMappingNotMatchingSchemaError extends Error {
    tag = 'OutputMappingNotMatchingSchemaError';
}
